// Build absolute URLs on the current deploy. BASE_URL is `/` in dev and
// `/sunrise-calendar/` on GitHub Pages — always ends in a trailing slash.

export function absoluteUrl(pathFromRoot: string): string {
  const base = import.meta.env.BASE_URL;
  const trimmed = pathFromRoot.replace(/^\//, '');
  return `${window.location.origin}${base}${trimmed}`;
}

export function authCallbackUrl(): string {
  return absoluteUrl('auth/callback');
}

export function successUrl(nonce: string): string {
  return absoluteUrl(`success?nonce=${encodeURIComponent(nonce)}`);
}
